import React from 'react';
import range from 'lodash/range';
import classNames from 'classnames';

export const MAX_BUTTONS = 5;

export default ({
	offset,
	limit,
	count,
	onClickPage,
}) => {
	const totalPages = Math.ceil(count / limit);
	const currentPageIndex = offset / limit;
	let firstButton;
	let lastButton;
	let middleButtons;
	let middleButtonsRange = [];

	if (totalPages <= MAX_BUTTONS) {
		middleButtonsRange = [0, totalPages];
	} else if (totalPages >= MAX_BUTTONS && currentPageIndex < MAX_BUTTONS - 1) {
		middleButtonsRange = [0, MAX_BUTTONS];
	} else if (totalPages >= MAX_BUTTONS && currentPageIndex > totalPages - MAX_BUTTONS) {
		middleButtonsRange = [totalPages - MAX_BUTTONS, totalPages];
	} else {
		middleButtonsRange = [currentPageIndex - Math.floor(MAX_BUTTONS / 2), currentPageIndex + Math.ceil(MAX_BUTTONS / 2)];
	}

	if (totalPages > MAX_BUTTONS && currentPageIndex > Math.ceil(MAX_BUTTONS / 2)) {
		firstButton = (
			<React.Fragment>
				<li className="list__item">
					<button
						title="Page 1"
						name="Page 1"
						onClick={() => onClickPage(0)}
						className="db button--pagination">
						1
					</button>
				</li>
				<li className="list__item">
					<p className="db button--pagination">…</p>
				</li>
			</React.Fragment>
		);
	}

	if (totalPages > MAX_BUTTONS && currentPageIndex <= totalPages - MAX_BUTTONS) {
		lastButton = (
			<React.Fragment>
				<li className="list__item">
					<p className="db button--pagination">…</p>
				</li>
				<li className="list__item">
					<button
						title={`Page ${totalPages}`}
						name={`Page ${totalPages}`}
						onClick={() => onClickPage(totalPages - 1)}
						className="db button--pagination">
						{totalPages}
					</button>
				</li>
			</React.Fragment>
		);
	}

	middleButtons = range(middleButtonsRange[0], middleButtonsRange[1]).map(pageIndex => (
		<li
			key={pageIndex}
			className="list__item">
			<button
				title={`Page ${pageIndex + 1}`}
				name={`Page ${pageIndex + 1}`}
				onClick={pageIndex !== currentPageIndex ? () => onClickPage(pageIndex) : null}
				className={classNames('db button--pagination', {
					active: pageIndex === currentPageIndex
				})}>
				{pageIndex + 1}
			</button>
		</li>
	));

	const previousButton = (
		<li className="list__item pr2">
			<button
				title="previous"
				name="previous"
				disabled={currentPageIndex === 0}
				onClick={() => onClickPage(currentPageIndex - 1)}
				className="db p1">
				<img
					alt="arrow"
					className="flip db"
					src="/images/icon-arrow-pagination.svg"
				/>
			</button>
		</li>
	);

	const nextButton = (
		<li className="list__item pl2">
			<button
				title="next"
				name="next"
				disabled={currentPageIndex + 1 === totalPages}
				onClick={() => onClickPage(currentPageIndex + 1)}
				className="db p1">
				<img
					alt="arrow"
					className="db"
					src="/images/icon-arrow-pagination.svg"
				/>
			</button>
		</li>
	);

	return (
		<ul className="list list--horizontal gutter--none tc align--middle">
			{previousButton}
			{firstButton}
			{middleButtons}
			{lastButton}
			{nextButton}
		</ul>
	);
};